import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/books/BooksAction";
import { getBookTypeOptions, redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { BookEditForm } from "./BookEditForm";

export function BookEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");
  const [bookTypeOptions, setBookTypeOptions] = useState([]);
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, book } = useSelector(
    (state) => ({
      actionsLoading: state.books.actionsLoading,
      isSuccess: state.books.isSuccess,
      type: state.books.type,
      book: state.books.book
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getBook(id));
    return () => dispatch(actions.cleanBooksState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Kitap";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    setBookTypeOptions(getBookTypeOptions(book.category));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [book && book.category]);

  /** Belli Bir Kitabı Kaydeder */
  const saveBook = (values) => {
    dispatch(actions.saveBook(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/kitaplar`), 2500);
  };

  const btnRef = useRef();  
  const saveBookClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <BookEditForm
            book={book}
            bookTypeOptions={bookTypeOptions}
            setBookTypeOptions={setBookTypeOptions}
            btnRef={btnRef} 
            saveBook={saveBook}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveBookClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}